<template>
  <div data-testid="enrollment-dialog-documents-tab">
    <div>
      <AttachmentUploader
        @uploaded="loadAttachments"
        ref="enrollment_attachment_uploader"
        :owner="{
          type: 'Business',
          // TODO: Change to logged in manager ID
          id: store.state.profile.business_id,
          child_id: enrollment.child_id,
        }"
        class="mb-4"
      />

      <AttachmentList
        v-if="attachments.length > 0"
        @delete="loadAttachments"
        :attachments="attachments"
      />
    </div>

    <StandardCard
      v-if="agreements?.length > 0"
      card-test-id="enrollment-dialog-agreements-card"
      title="Agreements"
    >
      <AgreementTable
        @change="loadAgreements"
        :agreements="agreements"
        :processing="processing"
        role="manager"
      />
    </StandardCard>
  </div>
</template>

<script setup>
import { useStore } from 'vuex';

import AgreementTable from '@/shared/components/agreement/AgreementTable.vue';
import AttachmentList from '@/shared/components/attachments/AttachmentList.vue';
import AttachmentUploader from '@/shared/components/attachments/AttachmentUploader.vue';
import useApi from '@/shared/composables/useApi';

const { api: Api } = useApi();
const store = useStore();

const props = defineProps({
  enrollment: {
    type: Object,
    default: null,
  },
  subsidyProgram: {
    type: Object,
    default: null,
  },
});

const agreements = ref([]);
const attachments = ref([]);
const processing = ref(false);

async function load() {
  void loadAttachments();
  void loadAgreements();
}

async function loadAgreements() {
  processing.value = true;

  const params = {
    child_id: props.enrollment.child_id,
    subsidy_program_id: props.subsidyProgram?.id,
    status: 'Signed',
  };
  const response = await Api.manager.agreement.index(params);
  agreements.value = response?.data;

  processing.value = false;
}

async function loadAttachments() {
  const params = {
    child_id: props.enrollment.child_id,
    subsidy_program_id: props.subsidyProgram?.id,
  };
  const response = await Api.manager.attachment.index(params);
  if (response?.status !== 200) return;

  attachments.value = response.data;
}

onMounted(load);
</script>
